import React, { useEffect, useRef } from 'react';
import 'swiper/css/bundle';
import { register } from 'swiper/element/bundle';
import ConditionCarouselWidgetCard from './condition-carousel-widget-card';
import InitialContext from 'state/static-data/InitialContext';

interface ConditionProp {
    title: string;
    imageUrl: string;
}
interface ConditionCarouselWidgetProps {
    conditions: ConditionProp[];
}

register();

const ConditionCarouselWidget = () => {
    const swiperElRef = useRef(null);
    const widgetAttr: ConditionCarouselWidgetProps = InitialContext.getConditionCarouselWidgetAttributes();

    useEffect(() => {
        const swiperContainer: any = swiperElRef.current;

        const params = {
            a11y: true,
            slidesPerView: 2.5,
            spaceBetween: 10,
            slidesOffsetBefore: 20,
            keyboard: {
                enabled: true,
            },
        };

        Object.assign(swiperContainer, params);
        swiperContainer.initialize();
    }, []);

    return (
        <div className='condition-carousel'>
            <swiper-container ref={swiperElRef} init={false}>
                {widgetAttr?.conditions?.map((condition, i) => (
                    <swiper-slide key={i}>
                        <ConditionCarouselWidgetCard
                            imageUrl={condition.imageUrl}
                            title={condition.title}
                        ></ConditionCarouselWidgetCard>
                    </swiper-slide>
                ))}
            </swiper-container>
        </div>
    );
};

export default ConditionCarouselWidget;
